import React from 'react';
import { Chip } from '@mui/material';

const StatusChip = ({ status, type = 'order', label, sx = {} }) => {
    const getStatusConfig = () => {
        if (type === 'user-role') {
            return status ?
                { label: 'Administrador', color: '#800020', bg: '#800020', text: '#ffffff' } :
                { label: 'Usuario', color: '#2e7d32', bg: '#2e7d32', text: '#ffffff' };
        }

        if (type === 'active') {
            return status ?
                { label: 'Activo', color: '#2e7d32', bg: '#e8f5e9', text: '#2e7d32' } :
                { label: 'Inactivo', color: '#9e9e9e', bg: '#f5f5f5', text: '#9e9e9e' };
        }

        if (type === 'value-type') {
            const types = {
                string: { label: 'Texto', bg: '#e3f2fd', color: '#1976d2' },
                integer: { label: 'Entero', bg: '#f3e5f5', color: '#7b1fa2' },
                decimal: { label: 'Decimal', bg: '#e8f5e9', color: '#388e3c' },
                boolean: { label: 'Booleano', bg: '#fff3e0', color: '#f57c00' },
                json: { label: 'JSON', bg: '#fce4ec', color: '#c2185b' },
                email: { label: 'Email', bg: '#e0f2f1', color: '#00796b' },
                url: { label: 'URL', bg: '#e1f5fe', color: '#0277bd' },
            };
            return types[status] || { label: status, bg: '#f5f5f5', color: '#9e9e9e' };
        }

        // Default: Order statuses
        const orderStatuses = {
            borrador: { label: 'Borrador', bg: '#f5f5f5', color: '#9e9e9e' },
            confirmado: { label: 'Confirmado', bg: '#fff3e0', color: '#f57c00' },
            en_elaboracion: { label: 'En Elaboración', bg: '#e3f2fd', color: '#1976d2' },
            listo: { label: 'Listo para Facturar', bg: '#e8f5e9', color: '#2e7d32' },
            facturado: { label: 'Facturado', bg: '#e0f7fa', color: '#00838f' },
            entregado: { label: 'Entregado', bg: '#e8f5e9', color: '#2e7d32' },
            cancelado: { label: 'Cancelado', bg: '#ffebee', color: '#c62828' },
            devuelto: { label: 'Devuelto', bg: '#f3e5f5', color: '#7b1fa2' },
        };

        return orderStatuses[status] || { label: label || status, bg: '#f5f5f5', color: '#9e9e9e' };
    };

    const config = getStatusConfig();

    return (
        <Chip
            label={label || config.label}
            size="small"
            sx={{
                bgcolor: config.bg,
                color: config.text || config.color,
                fontWeight: 600,
                fontSize: '0.75rem',
                ...sx
            }}
        />
    );
};

export default StatusChip;
